/* PAUL-3950: the App Service a company web address is bound to. One hostname serves one service, so a
   cinema with a branded webshop and a branded cash register needs two addresses. 0 is left unused so a
   missing payload value fails the backend's required check rather than landing on a real target. */
export enum CompanyDomainTarget {
  Webshop = 1,
  OrderToSeat = 2,
  CashRegister = 3,
  KitchenDisplay = 4,
}

export const CompanyDomainTargetTranslations: Record<CompanyDomainTarget, string> = {
  [CompanyDomainTarget.Webshop]: 'pos_dashboard.web_address.target.webshop',
  [CompanyDomainTarget.OrderToSeat]: 'pos_dashboard.web_address.target.order_to_seat',
  [CompanyDomainTarget.CashRegister]: 'pos_dashboard.web_address.target.cash_register',
  [CompanyDomainTarget.KitchenDisplay]: 'pos_dashboard.web_address.target.kitchen_display',
};
